const prepareDietPlans = (root) => {
  if (!root || root.dataset.rgClientFeedbackReady === 'true') return;

  const availability = root.querySelector('.rg-diet-plans__section-heading > p');
  availability?.remove();

  root.dataset.rgClientFeedbackReady = 'true';
};

const initializeClientFeedback = (scope = document) => {
  scope.querySelectorAll('[data-rg-diet-plans]').forEach(prepareDietPlans);
};

initializeClientFeedback();

document.addEventListener('shopify:section:load', (event) => {
  initializeClientFeedback(event.target);
});
